import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'confidence-picker',
  templateUrl: './confidence-picker.component.html'
})
export class ConfidencePickerComponent implements OnInit {

  @Input() selectedItems: any[] = [];

  @Input() options: ConfidencePickerOptions;

  @Output('onChange') onChange: EventEmitter<any> = new EventEmitter<any>();

  selectedDDOptions: any[] = [];

  availableItems = [
    {
      id: 1,
      itemName: 'High'
    },
    {
      id: 2,
      itemName: 'Medium'
    },
    {
      id: 3,
      itemName: 'Low'
    },
  ];

  ddSettings: any = {
    text: 'Select confidence',
    unSelectAllText: 'Remove all',
    enableSearchFilter: false
  }

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
    this.initSelected();
  }


  selectionChanged() {
    // determine if at least one is selected
    let oneSelected: boolean = this.selectedDDOptions.length > 0;

    if (!oneSelected) {
      this.modalService.show(AlertDialogComponent, Object.assign({}, {
        initialState: {
          message: `At least one must be selected. We've reset to the default selection`,
          confirmBtn: 'Ok'
        }
      }));

      //select the default options if none are selected but at least one is required
      setTimeout(() => {
        this.setDefaults();
        this.initSelected();
        this.onChange.emit(this.selectedItems);
      }, 50);
    }
    else {
      this.selectedItems.length = 0; // clear the array without loosing any references to it
      this.selectedDDOptions.forEach(ddt => {
        this.selectedItems.push(ddt.id);
      });
      this.onChange.emit(this.selectedItems);
    }
  }

  initSelected() {
    this.selectedItems.forEach(t => {
      let type = this.availableItems.find(et => { return et.id == t });
      this.selectedDDOptions.push(type);
    });
  }

  private setDefaults() {
    this.selectedItems.length = 0; // clear the array without loosing any references to it
    if(this.options.required){
      this.selectedItems = this.selectedItems.concat(this.options.default.include);
    }
  }

}


export interface ConfidencePickerOptions {
  required: boolean;  // require at least one to be selected
  default: {
    include: number[],
    exclude: number[]
  };
}



// WEBPACK FOOTER //
// ./client/app/global/confidence-picker/confidence-picker.component.ts